module.exports = __webpack_public_path__ + "img/appAsset-HostedPages--Layout-vertical.20de3d59.svg";